export default __webpack_public_path__ + "images/RE.d669884.png";